const AUDIO_MIME_BY_EXTENSION: Readonly<Record<string, string>> = Object.freeze({
  mp3: 'audio/mpeg',
  m4a: 'audio/mp4',
  mp4: 'audio/mp4',
  aac: 'audio/aac',
  wav: 'audio/wav',
  ogg: 'audio/ogg',
  oga: 'audio/ogg',
  opus: 'audio/ogg',
  flac: 'audio/flac',
  webm: 'audio/webm',
})

const IMAGE_MIME_BY_EXTENSION: Readonly<Record<string, string>> = Object.freeze({
  png: 'image/png',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  gif: 'image/gif',
  bmp: 'image/bmp',
  webp: 'image/webp',
})

export const AUDIO_ATTACHMENT_EXTENSIONS = Object.freeze(Object.keys(AUDIO_MIME_BY_EXTENSION))
export const IMAGE_ATTACHMENT_EXTENSIONS = Object.freeze(Object.keys(IMAGE_MIME_BY_EXTENSION))
export type AttachmentMediaKind = 'audio' | 'image' | 'file'

export function attachmentExtension(value: unknown): string {
  const source = String(value ?? '').split(/[?#]/, 1)[0]
  const dot = source.lastIndexOf('.')
  return dot < 0 ? '' : source.slice(dot + 1).trim().toLowerCase()
}

export function audioMimeForAttachment(value: unknown): string | undefined {
  return AUDIO_MIME_BY_EXTENSION[attachmentExtension(value)]
}

export function isAudioAttachment(value: unknown): boolean {
  return audioMimeForAttachment(value) !== undefined
}

export function imageMimeForAttachment(value: unknown): string | undefined {
  return IMAGE_MIME_BY_EXTENSION[attachmentExtension(value)]
}

export function isImageAttachment(value: unknown): boolean {
  return imageMimeForAttachment(value) !== undefined
}

export function attachmentMediaKind(value: unknown): AttachmentMediaKind {
  if (isAudioAttachment(value)) return 'audio'
  if (isImageAttachment(value)) return 'image'
  return 'file'
}

export function attachmentMimeForAttachment(value: unknown): string | undefined {
  return audioMimeForAttachment(value) ?? imageMimeForAttachment(value)
}
